import React, { useContext, useReducer, useMemo, useEffect } from 'react'
import Table, { TableHook } from '../../Table';
import { Box, IconButton, Tooltip } from '@mui/material';
import { api } from '../../../services/api';
import { lockedReducer } from '../../Utils/reducers';
import EditDescontoVolume from './edit';
import DeleteIcon from '@mui/icons-material/Delete';
import clsx from 'clsx';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { externalComponent } from '../../AppRoutes';
import EditIcon from '@mui/icons-material/Edit';
import { formatPercentage, formatCurrency } from '../../Utils/IntegerOnly';

const url = 'desconto_volume'

const columns = (setState) => {
    const columns = []
    columns.push({ field: 'client', headerName: 'Cliente', cellClassName: () => { return clsx('center', { selected: true, }); },
     renderCell: ({value}) => value.label, flex:1 })
     columns.push({ field: 'monthlyvolume', headerName: 'Volume Mensal', width: 300,
     renderCell: ({value}) => formatCurrency(value || 0) })
    columns.push({ field: 'discount', headerName: 'Desconto', width: 150, cellClassName: () => { return clsx('center', { selected: true, }); },
     renderCell: ({value}) => formatPercentage(value*100) })
    
    columns.push({
        field: 'acoes',
        headerName: 'Ações',
        width: 150,
        renderCell: (props) => {
            return (
                <Box>
                    <Tooltip title='Editar cliente'><IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton></Tooltip>
                    <Tooltip title='Deleta cliente'><IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton></Tooltip>
                </Box>
            )
        }
    })
    return columns
}

const deleteClient = async (setLoader, setState, getClients, id) => {
    setLoader(true)
    const res = await api.delete(`/${url}/${id}/`)
    if (res.status === 204) {
        await getClients(setLoader, setState)
        setState({ deleteRow: null })
    }
    setLoader(false)
}

const getClients = async (setLoader, setState) => {
    setLoader(true)
    const res = await api.get(`/${url}/`)
    if (res.status === 200) {
        setState({ rows: res.data })
    }
    setLoader(false)
}

const DescontoVolume = () => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        editRow: null,
        deleteRow: null
    })

    const [table] = TableHook()

    const { setLoader } = useContext(externalComponent)

    useEffect(() => {
        getClients(setLoader, setState)
    }, [])

    return (
        <>

            {
                state.editRow &&

                <EditDescontoVolume
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={() => getClients(setLoader, setState)}
                />

            }

            {
                state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir o desconto do cliente ${state.deleteRow.client.label} ?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => deleteClient(setLoader, setState, getClients, state.deleteRow.id)}
                />

            }

            <Box sx={{ height: '100%', overflow:'hidden' }}>

                <Table
                    paginationMode='client'
                    className='contabil-grid'
                    rows={state.rows}
                    columns={useMemo(() => columns(setState), [state.rows, state.edit])}
                    pagination={false}
                    toolbar
                    slots={{
                        addComponent: () => setState({ editRow: {} })
                    }}
                    rowHeight={30}
                    innerRef={table}
                    sx={{ height: '100%' }}
                />

            </Box>

        </>
    )
}

export default DescontoVolume;